// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__X-cmA","pageItem":"Pagination_pageItem__a4bMu"};